import { createUseStyles } from 'react-jss'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import Card from '../Card'
import File from '../File'
import { FileModel, FileType } from '../../redux/types'
import { RootState } from '../../redux/store'
import { useEffect, useState } from 'react'

interface Props {
  isCompanyGroupFile: boolean
}

const ImportFileForDeactivation = ({isCompanyGroupFile}: Props) => {
  const styles = useStyles()
  const { t } = useTranslation(['activations'])
  const files = useSelector((state: RootState) => state.files.files)
  const [deactivationFiles, setDeactivationFiles] = useState<FileModel[]>([])

  useEffect(() => {
    setDeactivationFiles(files.filter(file => file.type === FileType.employeeDeactivationFile))
  }, [files])

  return (
   <>
    {deactivationFiles.length > 0 &&
    <Card className={styles.importFilesContainer}>
      <h6 style={{marginBottom: 10}}>{t('importFileForDeactivation', { ns: 'activations' })}</h6>
      {deactivationFiles.map((file, index) => {
        return (
          <File file={file} key={`file_${index}`} isCompanyGroupFile={isCompanyGroupFile} />
        )
      })}
    </Card>
    }
  </>
  )
}

const useStyles = createUseStyles({
  importFilesContainer: {
    display: 'flex',
    flex: 1,
    width: '100%',
    flexDirection: 'column',
    marginBottom: 20
  }
})

export default ImportFileForDeactivation 